import StorageService from '../services/storage.js';

/**
 * Check if the user is a phone order user and display a banner if a user_id is found.
 * The function stores the user_id from URL parameters to localStorage for persistence
 * across page loads.
 */
export default function phoneOrderUser() {
  const URL_PARAMS_KEY = 'user_id';
  const BANNER_TEXT =
    'You are operating this site as a sales agent on behalf of a customer, and commissions will be awarded.';
  const storageService = StorageService();
  storeUserIdFromUrl();
  const userId = storageService.userId;

  updatePhoneOrderUserBanner(userId);

  function storeUserIdFromUrl() {
    const userId = new URLSearchParams(window.location.search).get(URL_PARAMS_KEY);
    if (userId && Number.isInteger(Number(userId))) {
      storageService.userId = userId;
    }
  }

  function updatePhoneOrderUserBanner(userId) {
    const element = document.getElementById('phone-order-user-notification');
    if (!element) {
      console.error('Phone order user banner element is not present in DOM.');
      return;
    }

    if (userId) {
      element.innerHTML = BANNER_TEXT;
      element.classList.remove('hidden');
    } else {
      element.innerHTML = '';
    }
  }
}
